<template>
    <steps-option
        :hidePlaceholders="true"
        @updateNavigation="updateNavigation"
    />
</template>

<script>
    import StepsOption from './StepsOption.vue';

    export default {
        components: {
            StepsOption,
        },

        computed: {
            builtFromSelfie() {
                return this.$store.state.builtFromSelfie;
            },
        },

        mounted() {
            if (this.builtFromSelfie) {
                // We need to delay things a bit.
                // Selfie choices are loaded...
                // ... then applied
                // ... which triggers a state change
                // ... which triggers a camera loading event
                // ... which loads new components
                //
                // If we show preview right away, the camera is not yet in the loading state and it will
                // take a snapshot of a blank pop.
                setTimeout(() => {
                    this.$store.dispatch('showAiPreviewModal', true);
                    this.$store.dispatch('showAiModal', false);
                }, 100);
            }
        },

        methods: {
            updateNavigation(navRules) {
                this.$emit('updateNavigation', navRules);
            },
        },
    };
</script>
